import type { RelayMetadata } from '@/contexts/AppContext';

/**
 * App default relays. Used as the initial `relayMetadata` for new users and as
 * a fallback when the user has no NIP-65 relay list configured (e.g. during
 * nostrconnect handshakes before any user relays have been loaded).
 */
export const APP_RELAYS: RelayMetadata = {
  relays: [
    { url: 'wss://relay.ditto.pub/', read: true, write: true },
    { url: 'wss://nos.lol/', read: true, write: true },
    { url: 'wss://relay.primal.net/', read: true, write: true },
    // Content-rich aggregators — read-only, they carry most public highlights.
    { url: 'wss://relay.damus.io/', read: true, write: false },
    { url: 'wss://relay.nostr.band/', read: true, write: false },
    { url: 'wss://relay.dreamith.to/', read: false, write: true },
  ],
  updatedAt: 0,
};

/** App relays we publish to — used to rebroadcast shared events so
 *  embeds/permalinks hydrate for anonymous viewers. */
export const APP_WRITE_RELAY_URLS = APP_RELAYS.relays.filter((r) => r.write).map((r) => r.url);

/** App relays we read from — used as nevent relay hints. */
export const APP_READ_RELAY_URLS = APP_RELAYS.relays.filter((r) => r.read).map((r) => r.url);
